export default __webpack_public_path__ + "static/media/message.01bfd32f.mp3";